module.exports = require('../node-fetch/node-fetch.js');
